import React from 'react';
import { Layout } from 'react-admin';
import { CustomAppBar } from './custom-app-bar';
import CustomNotification from './CustomNotification';

export const CustomLayout = (props: any) => {
  return <Layout {...props} appBar={CustomAppBar} notification={CustomNotification}/>;
};
